import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, inr, nfmt } from "./utils";
import { Info } from "@phosphor-icons/react";

export default function AdminDistributors() {
  const [data, setData] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/admin/distributors");
        setData(data);
      } catch (e) { setErr(e?.response?.data?.detail || "Failed"); }
    })();
  }, []);

  if (err) return <div className="nb-card p-3 bg-[#FF6B6B] text-white font-bold">{err}</div>;
  if (!data) return <p className="p-4 text-sm">Loading…</p>;

  return (
    <div className="space-y-4" data-testid="admin-distributors">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
        <Stat label="Distributors" value={nfmt(data.distributor_count)} testid="dist-count" />
        <Stat label="End customers" value={nfmt(data.end_customers)} testid="dist-customers" />
        <Stat label="Total invoiced" value={inr(data.invoiced_total)} testid="dist-invoiced" />
        <Stat label="Outstanding" value={inr(data.outstanding_total)} accent="#FF6B6B" testid="dist-outstanding" />
      </div>

      <div className="nb-card p-3 bg-[#FFD166]/40 flex items-start gap-2 text-sm">
        <Info size={16} weight="bold" className="flex-shrink-0 mt-0.5" />
        <p>{data.note}</p>
      </div>

      <div className="nb-card overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-[#F3F0E9] text-left">
            <tr>
              <th className="p-3 font-bold">Distributor</th>
              <th className="p-3 font-bold text-right">Customers</th>
              <th className="p-3 font-bold text-right">Invoices</th>
              <th className="p-3 font-bold text-right">Invoiced</th>
              <th className="p-3 font-bold text-right">Paid</th>
              <th className="p-3 font-bold text-right">Outstanding</th>
              <th className="p-3 font-bold text-right">Overdue</th>
              <th className="p-3"></th>
            </tr>
          </thead>
          <tbody>
            {(data.distributors || []).length === 0 && (
              <tr><td colSpan={8} className="p-6 text-center text-sm text-[#4A4A4A]">No data available</td></tr>
            )}
            {data.distributors.map((r) => (
              <tr key={r.user_id} className="border-t border-black/10" data-testid={`dist-row-${r.user_id}`}>
                <td className="p-3">
                  <div className="font-bold">{r.business_name || r.name}</div>
                  <div className="text-[11px] text-[#4A4A4A]">{r.email}</div>
                </td>
                <td className="p-3 text-right">{nfmt(r.total_customers)}</td>
                <td className="p-3 text-right">{nfmt(r.total_invoices)}</td>
                <td className="p-3 text-right">{inr(r.total_invoiced)}</td>
                <td className="p-3 text-right">{inr(r.total_paid)}</td>
                <td className="p-3 text-right">{inr(r.total_outstanding)}</td>
                <td className="p-3 text-right">{inr(r.overdue_amount)}</td>
                <td className="p-3 text-right"><Link to={`/admin/businesses/${r.user_id}`} className="nb-btn bg-white text-xs px-2 py-1">Open</Link></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function Stat({ label, value, accent = "#FFFFFF", testid }) {
  return (
    <div data-testid={testid} className="nb-card p-4" style={{ background: accent }}>
      <div className="text-[10px] font-bold uppercase tracking-[0.2em]">{label}</div>
      <div className="font-heading font-black text-3xl tracking-tighter mt-1">{value}</div>
    </div>
  );
}
